/**
 * Inven 도메인 Query Hook Wrapper
 *
 * Adapter를 사용하여 REST API를 호출합니다.
 */

import {useInfiniteQuery, useQuery} from '@tanstack/react-query';
import {INVEN_QUERY_KEY_MAP} from '../api/inven/constant';
import {invenFactory} from '../factory/invenFactory';

// ============================================
// useInvenMyInfoQuery
// ============================================

export function useInvenMyInfoQuery(
  ...args: Parameters<typeof invenFactory.invenMyInfo>
) {
  return useQuery(invenFactory.invenMyInfo(...args));
}

useInvenMyInfoQuery.getKey = (
  ...args: Parameters<typeof INVEN_QUERY_KEY_MAP.invenMyInfo>
) => [...INVEN_QUERY_KEY_MAP.invenMyInfo(...args)];

// ============================================
// useInvenRecommendListQuery
// ============================================

export function useInvenRecommendListQuery(
  ...args: Parameters<typeof invenFactory.invenRecommendList>
) {
  return useQuery(invenFactory.invenRecommendList(...args));
}

useInvenRecommendListQuery.getKey = (
  ...args: Parameters<typeof INVEN_QUERY_KEY_MAP.invenRecommendList>
) => [...INVEN_QUERY_KEY_MAP.invenRecommendList(...args)];

// ============================================
// useInfiniteInvenLikeListQuery
// ============================================

export function useInfiniteInvenLikeListQuery(
  ...args: Parameters<typeof invenFactory.infiniteInvenLikeList>
) {
  return useInfiniteQuery(invenFactory.infiniteInvenLikeList(...args));
}

useInfiniteInvenLikeListQuery.getKey = (
  ...args: Parameters<typeof INVEN_QUERY_KEY_MAP.infiniteInvenLikeList>
) => [...INVEN_QUERY_KEY_MAP.infiniteInvenLikeList(...args)];

// ============================================
// useInfiniteInvenPaidListQuery
// ============================================

export function useInfiniteInvenPaidListQuery(
  ...args: Parameters<typeof invenFactory.infiniteInvenPaidList>
) {
  return useInfiniteQuery(invenFactory.infiniteInvenPaidList(...args));
}

useInfiniteInvenPaidListQuery.getKey = (
  ...args: Parameters<typeof INVEN_QUERY_KEY_MAP.infiniteInvenPaidList>
) => [...INVEN_QUERY_KEY_MAP.infiniteInvenPaidList(...args)];

// ============================================
// useInfiniteInvenRecentListQuery
// ============================================

export function useInfiniteInvenRecentListQuery(
  ...args: Parameters<typeof invenFactory.infiniteInvenRecentList>
) {
  return useInfiniteQuery(invenFactory.infiniteInvenRecentList(...args));
}

useInfiniteInvenRecentListQuery.getKey = (
  ...args: Parameters<typeof INVEN_QUERY_KEY_MAP.infiniteInvenRecentList>
) => [...INVEN_QUERY_KEY_MAP.infiniteInvenRecentList(...args)];

// ============================================
// useInfiniteSearchInvenListQuery
// ============================================

export function useInfiniteSearchInvenListQuery(
  ...args: Parameters<typeof invenFactory.infiniteSearchInvenList>
) {
  return useInfiniteQuery(invenFactory.infiniteSearchInvenList(...args));
}

useInfiniteSearchInvenListQuery.getKey = (
  ...args: Parameters<typeof INVEN_QUERY_KEY_MAP.infiniteSearchInvenList>
) => [...INVEN_QUERY_KEY_MAP.infiniteSearchInvenList(...args)];
